export default __webpack_public_path__ + "static/media/Regular.e7eadd5d.png";